import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import {
  So5FixtureEvent,
  Sport,
} from '@sorare/core/src/__generated__/globalTypes';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Tab, TabBar } from '@sorare/core/src/atoms/navigation/TabBar';
import type {
  ANY_SPORT_MY_CIRCLES_EVENTTYPE_FIXTURE,
  ANY_SPORT_PLAY_EVENTTYPE_FIXTURE_REWARDS,
  ANY_SPORT_PLAY_EVENTTYPE_FIXTURE_TOP_PLAYERS,
} from '@sorare/core/src/constants/__generated__/routes';
import type { ANY_SPORT_PLAY_EVENTTYPE_FIXTURE_LINEUPS } from '@sorare/core/src/constants/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { glossary } from '@sorare/core/src/lib/glossary';

import { EventTypeSwitcherWidget } from 'components/home/EventTypeSwitcherWidget';
import type { FIXTURES } from 'lib/so5';

type Props = {
  baseRoute:
    | typeof ANY_SPORT_MY_CIRCLES_EVENTTYPE_FIXTURE
    | typeof ANY_SPORT_PLAY_EVENTTYPE_FIXTURE_LINEUPS
    | typeof ANY_SPORT_PLAY_EVENTTYPE_FIXTURE_REWARDS
    | typeof ANY_SPORT_PLAY_EVENTTYPE_FIXTURE_TOP_PLAYERS;
  currentEventType: So5FixtureEvent;
  defaultFixture?: keyof typeof FIXTURES;
};

export const EventTypeSwitcher = ({
  baseRoute,
  currentEventType,
  defaultFixture = 'ongoing',
}: Props) => {
  const navigate = useNavigate();
  const { generateSportContextPath, sport } = useSportContext();
  const [selectedEventType, setSelectedEventType] = useState(currentEventType);

  if (sport === Sport.NBA) {
    return (
      <EventTypeSwitcherWidget
        onClick={value => {
          navigate(
            generateSportContextPath(baseRoute, {
              params: {
                eventType: value.toLowerCase(),
                fixture: defaultFixture,
              },
            })
          );
        }}
      />
    );
  }

  return (
    <Vertical gap={0.5}>
      <TabBar
        variant="primary"
        value={selectedEventType}
        onValueChange={value => {
          setSelectedEventType(value as So5FixtureEvent);
          navigate(
            generateSportContextPath(baseRoute, {
              params: {
                eventType: value.toLowerCase(),
                fixture: defaultFixture,
              },
            })
          );
        }}
      >
        <Tab value={So5FixtureEvent.DAILY}>
          <FormattedMessage {...glossary.daily} />
        </Tab>
        <Tab value={So5FixtureEvent.CLASSIC}>
          <FormattedMessage {...glossary.biweekly} />
        </Tab>
      </TabBar>
    </Vertical>
  );
};
